import { VueConstructor } from 'vue';
import { TranslationCSVService } from './services/translation-csv.service';
import { TranslationReportService } from './services/translation-report.service';

const translationReportsActivated = process.env.VUE_APP_ACTIVATE_TRANSLATION_REPORTS === 'true';
const translationCSVMenuActivated = process.env.VUE_APP_ACTIVATE_TRANSLATION_CSV_MENU === 'true';

declare module 'vue/types/vue' {
  interface Vue {
    $translationReportService: TranslationReportService;
  }
}

export default class DevModule {
  static async install(Vue: VueConstructor<Vue>): Promise<void> {
    await DevModule.registerServices(Vue);
  }

  static async registerServices(Vue: VueConstructor<Vue>) {
    if (translationReportsActivated) {
      Vue.prototype.$translationReportService = new TranslationReportService();
      Vue.prototype.$t = Vue.prototype.$translationReportService.$t;
      Vue.prototype.translationService = Vue.prototype.$translationReportService.getTranslationService();
    }
    if (translationCSVMenuActivated) {
      Vue.prototype.$translationCSVService = new TranslationCSVService();
    }
  }
}
